const t = {
  name: "AngledLeft",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.0002 12V5H18.0002V12C18.0002 12.5523 17.5525 13 17.0002 13H7.41439L10.4144 10L9.00015 8.58582L3.58594 14L9.00015 19.4142L10.4144 18L7.41434 15H17.0002C18.6571 15 20.0002 13.6569 20.0002 12Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as AngledLeft
};
